import { PropsWithChildren } from 'react'

import styled from 'styled-components'

import { Box } from '@themenu/design-system'

import { useIsMobile } from '../../hooks/useIsMobile'

export const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 328px;
`

export const PushButtonToBottom = ({ children }: PropsWithChildren): JSX.Element => {
  const isMobileScreen = useIsMobile()
  return (
    <Box mt={isMobileScreen ? 48 : 24} display="flex" flex="1" alignItems="flex-end">
      {children}
    </Box>
  )
}
